// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

export type ProductFilterTextState = Readonly<{
    text: string;
}>;

const initialState: ProductFilterTextState = {
    text: "",
};
const reducer = {
    "xProductFilterText/SetText": (draft: Draft<ProductFilterTextState>, action: { text: string }) => {
        draft.text = action.text;
    },
};

const xProductFilterText = createTypedReducerWithImmer(initialState, reducer);

(reducers as any).xProductFilterText = xProductFilterText;

export type xProductFilterTextState = {
    xProductFilterText: ProductFilterTextState;
} & ApplicationState;

type ProductFilterTextReducers = {
    query: typeof xProductFilterText;
};

export type xProductFilterText = Parameters<ProductFilterTextReducers[keyof ProductFilterTextReducers]>[1] | AnyAction;
